import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectComponent } from '@ng-select/ng-select';
import { ToastrService } from 'ngx-toastr';
import { DhukanDataService } from 'src/app/services/dhukan/dhukan-data.service';
import { LoginDataService } from 'src/app/services/dhukan/login-data.service';
import { ConfirmationDialogService } from '../../confirmation-dialog/confirmation-dialog.service';
import { AddrawmaterialComponent } from '../../rawmaterial/addrawmaterial/addrawmaterial.component';

@Component({
  selector: 'app-addicomedetail',
  templateUrl: './addicomedetail.component.html',
  styleUrls: ['./addicomedetail.component.css']
})
export class AddicomedetailComponent implements OnInit {

  @ViewChild('Selecter', { static: false }) ngselect: NgSelectComponent;

  //Save Validation
  submitted: boolean;
  successfully: boolean;
  saveloading: boolean;

  isload: boolean = true;

  israwmaterialaddmode: boolean = false;

  rtnform: string = "";
  errtxt: any = "";


  purchaseBO: any = {}


  ismanualclose: boolean;

  isaccountaddmode: boolean = false;

  discounttype: string = "";

  productfindColl: any;
  taxColl: any;
  rawmaterialColl: any;
  isLoadingResult: boolean;

  filterpaymentmodeid: number = 0;

  incomeform = new FormGroup({
    incomedetailsid: new FormControl(0),
    incomeid: new FormControl(0),
    rawmaterialid: new FormControl(null, Validators.required),
    rawmaterialname: new FormControl(null),
    qty: new FormControl(null, Validators.required),
    unitprice: new FormControl(null, Validators.required),
    subtotal: new FormControl(null),
    uomid: new FormControl(null, Validators.required),
    taxid: new FormControl(null, Validators.required),
    taxname: new FormControl(null),
    taxrate: new FormControl(null),
    taxamt: new FormControl(null),
    cgsttaxrate: new FormControl(null),
    cgsttaxamt: new FormControl(null),
    sgsttaxrate: new FormControl(null),
    sgsttaxamt: new FormControl(null),
    igsttaxrate: new FormControl(null),
    igsttaxamt: new FormControl(null),
    taxable: new FormControl(null),
    nettotal: new FormControl(null),
    inactive: new FormControl(null),
  });


  formname: String = "Income";



  @Input() incomedetailsid: number = 0
  @Input() incomeid: number = 0

  @Input() incomedetailsBO: any = {};

  @Output() emitData = new EventEmitter();

  constructor(private appService: DhukanDataService, private activeModal: NgbActiveModal, private route: ActivatedRoute,
    private productFindService: NgbModal, private confirmationDialogService: ConfirmationDialogService,
    public router: Router, private toastr: ToastrService, public loginService: LoginDataService, private datePipe: DatePipe) {

    this.fnServiceChanges();
  }


  fnServiceChanges() {

  }

  ngOnInit() {
    try {
      this.fnOnInitForm();
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnOnInitForm() {
    try {
      this.incomeform.reset();
      this.fnInitializeForm();

      this.fnGetRawmaterial();
      this.fnGetTax();
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }
  ngAfterViewInit() {
    //  this.loginService.fnSetFirstControlFocusLookup(this.ngselect);


  }



  fnInitializeForm() {
    this.incomeform.setValue({
      incomedetailsid: this.incomedetailsBO.incomedetailsid,
      incomeid: this.incomedetailsBO.incomeid,
      rawmaterialid: this.incomedetailsBO.rawmaterialid,
      rawmaterialname: this.incomedetailsBO.rawmaterialname,
      qty: this.incomedetailsBO.qty,
      unitprice: this.incomedetailsBO.unitprice,
      subtotal: this.incomedetailsBO.subtotal,
      uomid: this.incomedetailsBO.uomid,
      taxid: this.incomedetailsBO.taxid,
      taxname: this.incomedetailsBO.taxname,
      taxrate: this.incomedetailsBO.taxrate,
      taxamt: this.incomedetailsBO.taxamt,
      cgsttaxrate: this.incomedetailsBO.cgsttaxrate,
      cgsttaxamt: this.incomedetailsBO.cgsttaxamt,
      sgsttaxrate: this.incomedetailsBO.sgsttaxrate,
      sgsttaxamt: this.incomedetailsBO.sgsttaxamt,
      igsttaxrate: this.incomedetailsBO.igsttaxrate,
      igsttaxamt: this.incomedetailsBO.igsttaxamt,
      taxable: this.incomedetailsBO.taxable,
      nettotal: this.incomedetailsBO.nettotal,
      inactive: false,
    })
  }




  fnValidation() {
    var _ischeck = false;
    var _detailscheck = false;
    var qty = this.incomeform.get('qty').value;
    if (this.loginService.fnCheckZeroDetcimal(qty) === 0) {
      this.errtxt = "Quantity is cannot be empty"
      this.incomeform.controls['inactive'].setErrors({ 'notfound': true });
      _ischeck = true;
    }


    // for (let row of this.purchasedetailscoll) {
    //   if (row.rawmaterialid > 0) {
    //     _detailscheck = true;
    //   }
    // }

    // if (!_detailscheck) {
    //   this.errtxt = "Purchase Details cannot be empty"
    //   this.incomeform.controls['inactive'].setErrors({ 'notfound': true });
    //   _ischeck = true;
    // }
    // if (!_ischeck) {
    //   for (let row of this.purchasedetailscoll) {

    //     if (row.rawmaterialid > 0 && this.loginService.fnCheckZeroDetcimal(row.qty) === 0) {
    //       this.errtxt = "Quantity is cannot be empty"
    //       this.incomeform.controls['inactive'].setErrors({ 'notfound': true });
    //       _ischeck = true;
    //     }

    //   }
    // }
    return _ischeck;

  }

  fnResetValidation() {

    if (this.incomeform.get('inactive')) {
      this.incomeform.controls['inactive'].setErrors(null);
    }

  }


  //Save Btn Click
  fnSaveBtnClick() {

    try {
      if (this.saveloading) {
        return;
      }

      this.submitted = true;
      this.successfully = false;

      this.fnResetValidation()
      //Validate

      if (this.incomeform.valid) {

        if (this.fnValidation()) {

          return false
        }


        this.saveloading = true;



        //Check
        var data = {
          incomedetailsid: this.incomeform.get('incomedetailsid').value,
          incomeid: this.incomeform.get('incomeid').value,
          rawmaterialid: this.incomeform.get('rawmaterialid').value,
          rawmaterialname: this.incomeform.get('rawmaterialname').value,
          qty: this.incomeform.get('qty').value,
          unitprice: this.incomeform.get('unitprice').value,
          subtotal: this.incomeform.get('subtotal').value,
          uomid: this.incomeform.get('uomid').value,
          taxid: this.incomeform.get('taxid').value,
          taxname: this.incomeform.get('taxname').value,
          taxrate: this.incomeform.get('taxrate').value,
          taxamt: this.incomeform.get('taxamt').value,
          cgsttaxrate: this.incomeform.get('cgsttaxrate').value,
          cgsttaxamt: this.incomeform.get('cgsttaxamt').value,
          sgsttaxrate: this.incomeform.get('sgsttaxrate').value,
          sgsttaxamt: this.incomeform.get('sgsttaxamt').value,
          igsttaxrate: this.incomeform.get('igsttaxrate').value,
          igsttaxamt: this.incomeform.get('igsttaxamt').value,
          taxable: this.incomeform.get('taxable').value,
          nettotal: this.incomeform.get('nettotal').value,
        }

        var result = {
          'checkstatus': 'DONE',
          'data': data
        }

        this.emitData.emit(result);
        this.activeModal.close(true);



      }
    } catch (ex) {
      this.saveloading = false;

      this.fnShowErrorMsg(ex);
    }

  }




  //Close
  async fnCloseForm() {

    try {


      var result = {
        'checkstatus': 'CANCEL',
        'data': null
      }

      this.emitData.emit(result);
      this.activeModal.close(true);

    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }


  //Details

  fnGetRawmaterial() {
    this.isLoadingResult = true;

    var data = {
      'rawmaterialid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
      'organizationid': this.loginService.fnGetOrganizationId(),
    }
    this.appService.getRawmaterial(data)
      .subscribe(
        (res) => {
          this.rawmaterialColl = res.json().result;

          this.isLoadingResult = false;
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }
  fnReLoadRawmaterial() {


    var data = {
      'rawmaterialid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
      'organizationid': this.loginService.fnGetOrganizationId(),

    }
    this.appService.getRawmaterial(data)
      .subscribe(
        (res) => {
          this.fnChangeRawmaterial()
        }, (err) => {
          this.toastr.error('Error', err);
        })
  }

  fnGetTax() {
    this.isLoadingResult = true;

    var data = {
      'taxid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
      'organizationid': this.loginService.fnGetOrganizationId(),

    }
    this.appService.getTax(data)
      .subscribe(
        (res) => {
          this.taxColl = res.json().result;


          this.isLoadingResult = false;
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }


  fnCalcDetails() {

    var row = {
      incomedetailsid: this.incomeform.get('incomedetailsid').value,
      incomeid: this.incomeform.get('incomeid').value,
      rawmaterialid: this.incomeform.get('rawmaterialid').value,
      rawmaterialname: this.incomeform.get('rawmaterialname').value,
      qty: this.incomeform.get('qty').value,
      unitprice: this.incomeform.get('unitprice').value,
      subtotal: this.incomeform.get('subtotal').value,
      uomid: this.incomeform.get('uomid').value,
      taxid: this.incomeform.get('taxid').value,
      taxname: this.incomeform.get('taxname').value,
      taxrate: this.incomeform.get('taxrate').value,
      taxamt: this.incomeform.get('taxamt').value,
      cgsttaxrate: this.incomeform.get('cgsttaxrate').value,
      cgsttaxamt: this.incomeform.get('cgsttaxamt').value,
      sgsttaxrate: this.incomeform.get('sgsttaxrate').value,
      sgsttaxamt: this.incomeform.get('sgsttaxamt').value,
      igsttaxrate: this.incomeform.get('igsttaxrate').value,
      igsttaxamt: this.incomeform.get('igsttaxamt').value,
      taxable: this.incomeform.get('taxable').value,
      nettotal: this.incomeform.get('nettotal').value,
    }

    this.incomedetailsBO.subtotal = row.qty * row.unitprice;

    this.incomeform.patchValue({ 'subtotal': this.incomedetailsBO.subtotal });
    //this.subtotal = this.subtotal + Number(row.subtotal)


    this.incomedetailsBO.taxamt = Number(this.fnConvertDecimal(this.incomedetailsBO.subtotal)) * Number(this.fnConvertDecimal(row.taxrate)) / 100
    this.incomeform.patchValue({ 'taxamt': this.incomedetailsBO.taxamt });

    //GST      
    this.incomedetailsBO.cgsttaxamt = Number(this.fnConvertDecimal(this.incomedetailsBO.taxamt)) / 2
    this.incomedetailsBO.sgsttaxamt = Number(this.fnConvertDecimal(this.incomedetailsBO.taxamt)) / 2
    this.incomedetailsBO.igsttaxamt = 0

    this.incomeform.patchValue({
      'cgsttaxamt': this.incomedetailsBO.cgsttaxamt,
      'sgsttaxamt': this.incomedetailsBO.sgsttaxamt,
      'igsttaxamt': this.incomedetailsBO.igsttaxamt
    })

    this.incomedetailsBO.taxable = Number(this.fnConvertDecimal(this.incomedetailsBO.subtotal));
    this.incomeform.patchValue({ 'taxable': this.incomedetailsBO.taxable });

    this.incomedetailsBO.nettotal = Number(this.fnConvertDecimal(this.incomedetailsBO.taxable)) + Number(this.fnConvertDecimal(this.incomedetailsBO.taxamt))
    this.incomeform.patchValue({ 'nettotal': this.incomedetailsBO.nettotal });
  }




  fnChangeRawmaterial() {

    var row = {
      rawmaterialid: this.incomeform.get('rawmaterialid').value,
    }

    var _prodname = "", _uomid = null, _unitprice = 0, _taxid = null;

    for (let abo of this.rawmaterialColl) {
      if (row.rawmaterialid === abo.rawmaterialid) {
        _prodname = abo.rawmaterialname;
        _unitprice = abo.purchaseprice;
        _uomid = abo.purchaseuomid;
        _taxid = abo.taxid;
      }
    }
    this.incomedetailsBO.rawmaterialname = _prodname;
    this.incomedetailsBO.unitprice = _unitprice;
    this.incomedetailsBO.uomid = _uomid;
    this.incomedetailsBO.taxid = _taxid;

    this.incomeform.patchValue({ 'rawmaterialname': this.incomedetailsBO.rawmaterialname });
    this.incomeform.patchValue({ 'unitprice': this.incomedetailsBO.unitprice });
    this.incomeform.patchValue({ 'uomid': this.incomedetailsBO.uomid });
    this.incomeform.patchValue({ 'taxid': this.incomedetailsBO.taxid });

    this.fnChangeTax()
  }


  fnChangeTax() {


    var row = {
      taxid: this.incomeform.get('taxid').value,
    }



    var _taxname = "", _taxrate = 0;

    var _cgsttaxrate = 0, _sgsttaxrate = 0, _igsttaxrate = 0;

    for (let abo of this.taxColl) {
      if (row.taxid === abo.taxid) {
        _taxname = abo.taxname;
        _taxrate = abo.taxrate;
        _cgsttaxrate = abo.cgsttaxrate;
        _sgsttaxrate = abo.sgsttaxrate;
        _igsttaxrate = abo.igsttaxrate;
      }
    }
    this.incomedetailsBO.taxname = _taxname;
    this.incomedetailsBO.taxrate = _taxrate;
    this.incomedetailsBO.cgsttaxrate = _cgsttaxrate;
    this.incomedetailsBO.sgsttaxrate = _sgsttaxrate;
    this.incomedetailsBO.igsttaxrate = _igsttaxrate;

    this.incomeform.patchValue({ 'taxname': this.incomedetailsBO.taxname });
    this.incomeform.patchValue({ 'taxrate': this.incomedetailsBO.taxrate });
    this.incomeform.patchValue({ 'cgsttaxrate': this.incomedetailsBO.cgsttaxrate });
    this.incomeform.patchValue({ 'sgsttaxrate': this.incomedetailsBO.sgsttaxrate });
    this.incomeform.patchValue({ 'igsttaxrate': this.incomedetailsBO.igsttaxrate });


    this.fnCalcDetails()

  }



  //AddProduct
  private fnAddRawmaterial(index) {

    const modalRef = this.productFindService.open(AddrawmaterialComponent, { size: <any>'xxl' });
    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

      this.fnGetRawmaterial();

      if (receivedEntry > 0) {
        this.incomedetailsBO.rawmaterialid = receivedEntry
      }
      this.fnReLoadRawmaterial();

    });
  }

  fnInsertActivityLog(action, refno, desc) {
    try {
      var data = {
        logtype: action,
        logat: this.formname,
        refnum: refno,
        logdescr: desc,
        logby: this.loginService.fnGetModUserId(),
        'companyid': this.loginService.fnGetCompanyId()

      }


      this.appService.fnInsertActivity(data).subscribe(
        (res) => {
        },
        (err) => {

        });

    } catch {

    }
  }

  fnConvertDecimal(value) {
    if (!value) {
      return 0
    }
    else {
      return value
    }

  }


  fnFormatDatetime(dt) {
    if (dt) {
      if (dt === "") {
        return null
      }
      else {
        return this.datePipe.transform(dt, "yyyy-MM-dd")
      }

    } else {
      return null
    }

  }
  fnConvertDatetime(dt) {
    if (dt) {
      if (dt === "") {
        return null
      }
      else {
        var dateParts = dt.split("-");
        var sdate = new Date(+dateParts[0], dateParts[1] - 1, +dateParts[2] + 1);
        sdate.setMinutes(sdate.getMinutes() + sdate.getTimezoneOffset());
        return sdate;
      }

    } else {
      return null
    }

  }


  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }







}